import clsx from "clsx";
import { PropsWithChildren } from "react";
import { PropsWithStyling } from "../@types/common";
import styles from "./table-display-title.module.scss";

type Props = PropsWithStyling<PropsWithChildren>;

const TableDisplayTitle = ({ children, className, style }: Props) => (
  <div className={clsx(styles.displayTitle, className)} style={style}>
    {children}
  </div>
);

export default TableDisplayTitle;
